<template>
  <div class="row">
    <div v-for="property in properties" :key="property.id" class="col-md-6 mb-6">
      <div class="single-blog-card card border-0 shadow-sm h-100 rounded-5 overflow-hidden">

        <!-- 📸 Свайпер с fade-эффектом и стрелками -->
        <Swiper
          :modules="[Autoplay, Pagination, Navigation, EffectFade]"
          effect="fade"
          :fadeEffect="{ crossFade: true }"
          :autoplay="{ delay: 4000 }"
          :loop="true"
          :pagination="{ clickable: true }"
          navigation
          class="property-swiper"
        >
          <SwiperSlide
            v-for="(img, i) in property.preview_images"
            :key="i"
          >
            <img
              :src="img"
              alt="Фото квартиры"
              loading="lazy"
              class="fade-img"
              @load="onImageLoad($event)"
            />
          </SwiperSlide>
        </Swiper>

        <!-- 📋 Контент -->
        <div class="card-body d-flex flex-column">
          <h3 class="h5 mb-2 card-title">
            <router-link
              :to="`/public/properties/${property.id}`"
              class="text-decoration-none text-dark"
            >
              {{ property.title }}
            </router-link>
          </h3>

          <div class="post-meta mb-2 small text-muted">
            <ul class="list-inline meta-list mb-1">
              <li class="list-inline-item">
                <span
                  class="purpose-badge"
                  :class="`purpose-${property.purpose}`"
                >
                  {{ $t(`property_cards.purpose.${property.purpose}`) }}
                </span>
              </li>
              <li class="list-inline-item">
               {{ property.country_flag }}  {{ property.country }} / {{ property.city }} / {{ property.district }}
              </li>
              <li class="list-inline-item">
                {{ $t('property_cards.rooms') }} {{ property.rooms }}
              </li>
              <li class="list-inline-item">
                {{ $t('property_cards.area') }} {{ property.gross_area }} м²
              </li>
            </ul>
          </div>

          <PropertyPriceRange
            v-if="property.evaluation_predictions"
            :price="Number(property.price)"
            :medianPrice="Number(property.evaluation_predictions.median_price)"
            :averagePrice="Number(property.evaluation_predictions.average_price)"
          />

          <a
            :href="`/public/properties/${property.id}`"
            class="btn btn-outline-primary btn-sm mt-3 align-self-start"
          >
            {{ $t('property_cards.more') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'

import PropertyPriceRange from '../../components/PropertyPriceRange.vue'

defineProps({ properties: Array })

const onImageLoad = (event) => {
  event.target.classList.add('loaded')
}
</script>

<style scoped>
/* 🔄 Плавное появление изображений */
.fade-img {
  opacity: 0;
  transition: opacity 1s ease-in-out;
  width: 100%;
  height: 300px;
  object-fit: cover;
}
.fade-img.loaded {
  opacity: 1;
}

/* 🧭 Контейнер свайпера */
.property-swiper {
  position: relative;
  width: 100%;
  height: 300px;
  background-color: #f8f9fa;
}

/* ⚪ Пагинация */
.property-swiper .swiper-pagination-bullet {
  background: rgba(255, 255, 255, 0.6);
}
.property-swiper .swiper-pagination-bullet-active {
  background: #007bff;
}

/* ⬅️➡️ Стрелки навигации */
.property-swiper .swiper-button-prev,
.property-swiper .swiper-button-next {
  color: white;
  background: rgba(0, 0, 0, 0.35);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: background 0.3s, transform 0.3s;
}
.property-swiper .swiper-button-prev:hover,
.property-swiper .swiper-button-next:hover {
  background: rgba(0, 0, 0, 0.6);
  transform: scale(1.1);
}
.property-swiper .swiper-button-prev::after,
.property-swiper .swiper-button-next::after {
  font-size: 16px;
  font-weight: bold;
}

/* ✨ Hover эффект карточки */
.single-blog-card {
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.single-blog-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.12);
}

/* 🏷 Badge назначения */
.purpose-badge {
  display: inline-block;
  padding: 4px 10px;
  font-size: 0.7rem;
  font-weight: 600;
  border-radius: 999px;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* 🎨 Цвета по типу сделки */
.purpose-sale {
  background-color: #198754; /* зелёный */
  color: #fff;
}

.purpose-rent {
  background-color: #0d6efd; /* синий */
  color: #fff;
}

.purpose-short_term {
  background-color: #ffc107; /* жёлтый */
  color: #000;
}

</style>
